import request from "@/utils/request";

/**
 * 医院环境接口
 *
 */
export function hospitalEnvironmentApi() {
  return {
    get: () => {
      return request({
        url: "/website/hospitalEnvironment/front/list",
        method: "get",
      });
    },
  };
}
